import { Injectable } from '@angular/core';
import { StateStore } from '@shared/store/state-store';

export interface LayoutState {
  isSideBarOpen: boolean;
  showLoginDialog: boolean;
  showAppMenu: boolean;
  isLoading: boolean;
  isFullscreen: boolean;
}

export function createInitialState(): LayoutState {
  return {
    isSideBarOpen: false,
    showLoginDialog: false,
    showAppMenu: false,
    isLoading: false,
    isFullscreen: false
  };
}

@Injectable({ providedIn: 'root' })
export class LayoutStore extends StateStore<LayoutState> {
  constructor() {
    super(createInitialState);
  }
}
